<template>
    <div class="app-container">
      <!-- 顶部四个数据统计模块 -->
      <div class="statistics-container">
        <div class="statistic-card card-orange">
          <div class="statistic-value" style="color:#e6a23c">{{topData.poQty || 0}}</div>
          <div class="statistic-label">{{ $t('BusinessStockMovementLang.PO_INBOUND') }}</div>
        </div>
        <div class="statistic-card card-purple">
          <div class="statistic-value" style="color:#722ed1">{{topData.orderQty || 0}}</div>
          <div class="statistic-label">{{ $t('BusinessStockMovementLang.ORDER_OUTBOUND') }}</div>
        </div>
        <div class="statistic-card card-pink">
          <div class="statistic-value" style="color:#eb2f96">{{topData.returnQty || 0}}</div>
          <div class="statistic-label">{{ $t('BusinessStockMovementLang.CUSTOMER_RETURNS') }}</div>
        </div>
        <div class="statistic-card card-cyan" v-if="!$store.getters.cusId">
          <div class="statistic-value" style="color:#13c2c2">{{topData.adjustQty || 0}}</div>
          <div class="statistic-label">{{ $t('BusinessStockMovementLang.STOCK_ADJUSTMENTS') }}</div>
        </div>
      </div> 
      <BjPage ref="BjPage" :get-action="queryApi" :query-params="queryParams" :col-span="colSpan" :before-reset-search="beforeResetSearch" @afterFetchOriginalData="afterFetchOriginalData" @showSetting="SortableTable.show" @header-dragend="SortableTable.handleHeaderDragend" @header-contextmenu="SortableTable.handleHeaderContextmenu">
        <template v-slot:baseForm>
          <el-col :span="colSpan">
            <el-form-item :label="$t('BusinessStockMovementLang.DATE')">
              <BjDateRangePicker v-model="queryParamsTime_order" :placeholder="$t('BusinessStockMovementLang.DATE')" @change="handleQuery"/>
            </el-form-item>
          </el-col>
          <el-col :span="colSpan">
            <el-form-item :label="$t('BusinessStockMovementLang.SKU')" prop="sku">
              <BjInput v-model="queryParams.sku" :placeholder="$t('BusinessStockMovementLang.SKU')" @keyup.enter.native="handleQuery" />
            </el-form-item>
          </el-col>
          <el-col :span="colSpan">
            <el-form-item :label="$t('BusinessStockMovementLang.TYPE')" prop="bizType">
              <BjSelectLov v-model="queryParams.bizType" :option-list="bizTypeList" :placeholder="$t('BusinessStockMovementLang.TYPE')" @change="handleQuery"/>
            </el-form-item>
          </el-col>
        </template>
        <template v-slot:tableOperation>
          <el-col>
            <el-button type="primary" class="main-btn" @click="onExport">{{ $t('exportText') }}</el-button>
          </el-col>
        </template>
        <template v-slot:tableColumn>
          <template v-for="(col, index) in dropCols">
            <el-table-column v-if="col.prop !== 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || false" align="center" class-name="item">
              <template slot-scope="scope">
                <el-tag v-if="col.prop === 'bizType'" type="success">{{ $t(bizTypeList.bjGet(scope.row.bizType)) }}</el-tag>
                <!-- <template v-else-if="col.prop == 'clientCode'">{{ clientCodeList.bjGet(scope.row.clientCode) }}</template> -->
                <span v-else>{{ scope.row[col.prop] | timeFilters(scope.row[col.prop]) }}</span>
              </template>
            </el-table-column>
          </template>
        </template>
      </BjPage>
    </div>
  </template>
  <script>
  import pageMiXin from '@/utils/page-mixin.js';
  import { orderApi } from '@/api';

  export default {
    name: 'BusinessStockMovement',
    components: { },
    mixins: [pageMiXin],
    data() {
      return {
        colSpan: 4,
        queryApi: orderApi.getStockMovePageList,
        isResetting: false,
        // 查询参数
        queryParamsTime_order: [],
        queryParams: {
          startTime : null,
          endTime : null,
          sku: null,
          bizType: null,
        },
        labelList1: [
          { label: this.$t('BusinessStockMovementLang.DATE'), prop: 'bizTime', isCheck: true, disabled: false, },
          { label: this.$t('BusinessStockMovementLang.SKU'), prop: 'sku', isCheck: true, disabled: false, },
          { label: this.$t('BusinessStockMovementLang.TYPE'), prop: 'bizType', isCheck: true, disabled: false, },
          { label: this.$t('BusinessStockMovementLang.QTY'), prop: 'qty', isCheck: true, disabled: false, },
          { label: this.$t('BusinessStockMovementLang.REFERENCE'), prop: 'refNo', isCheck: true, disabled: false, },
          { label: this.$t('BusinessStockMovementLang.USER'), prop: 'userId', isCheck: true, disabled: false, },
          { label: this.$t('table.operationText'), prop: 'bjTableAction', isCheck: true, disabled: false, width: 150 }
        ],
        topData:{},
      };
    },
    computed: {
      labelList() {
        // return !(!this.$store.getters.cusId && this.queryParams.bizType == 'ADJUSTMENT') ? this.labelList1.filter(item => item.prop != 'userId') : this.labelList1;
        return this.$store.getters.cusId ? this.labelList1.filter(item => item.prop != 'userId') : this.labelList1;
      },
      bizTypeList() {
        if (!this.$store.getters.cusId) {
          return [
            {label:this.$t('BusinessStockMovementLang.type1'),value:'PO INBOUND'},
            {label:this.$t('BusinessStockMovementLang.type2'),value:'ORDER OUTBOUND'},
            {label:this.$t('BusinessStockMovementLang.type3'),value:'RETURN'},
            {label:this.$t('BusinessStockMovementLang.type4'),value:'ADJUSTMENT'}]
        } else {
          return [
            {label:this.$t('BusinessStockMovementLang.type1'),value:'PO INBOUND'},
            {label:this.$t('BusinessStockMovementLang.type2'),value:'ORDER OUTBOUND'},
            {label:this.$t('BusinessStockMovementLang.type3'),value:'RETURN'}]
        }
      }
    },
    watch: {
      queryParamsTime_order(v) {
        this.queryParams.startTime = (v || [])[0];
        this.queryParams.endTime = (v || [])[1];
      },
    },
    methods: {
      handleQuery() {
        if (this.isResetting) return;
        setTimeout(() => {
          this.reFresh();
        }, 300);
      },
      /** 处理返回数据格式 */
      afterFetchOriginalData(res) {
        console.log(res,'res');
        // 优化列表页数据
        if (res.records) {
          this.topData = res;
          res.content = res.records.content || [];
          res.totalElements = Number(res.records.totalElements) || 0;
          res.totalPages = Number(res.records.totalPages) || 0;
        }else{
          this.topData = {};
          res.content = [];
          res.totalElements = 0;
          res.totalPages = 0;
        }
      },
      // 导出文件 后端接口导出
      onExport() {
        orderApi.exportStockMovePageList(this.queryParams).then(res => {
          if (res.failed) return ;
          const csvStr = res.message;
          const rows = csvStr.split('\n').filter(row => row.trim());
          if (rows.length < 2) return this.$message.warning('No data to export');
          const headers = rows[0].split(',');
          const data = rows.slice(1).map(row => {
            const cols = row.split(',');
            const obj = {};
            headers.forEach((h, i) => {
              obj[h] = cols[i] || '';
            });
            return obj;
          });
          const XLSX = require('xlsx');
          const ws = XLSX.utils.json_to_sheet(data);
          const wb = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(wb, ws, 'StockMovement');
          XLSX.writeFile(wb, 'StockMovement.xlsx');
        });
      },
      /** 重置按钮操作 */
      beforeResetSearch() {
        this.isResetting = true;
        this.queryParamsTime_order = [];

        return new Promise(resolve => {
          this.$nextTick(() => {
            this.isResetting = false;
            resolve();
          });
        });
      },
    },
  };
  </script>
  <style lang="scss" scoped>
    ::v-deep .bj-page .el-form-item__label {
      display: none;
    }
    // 统计卡片容器
    .statistics-container {
      display: flex;
      gap: 16px;
      margin-bottom: 20px;

      .statistic-card {
      flex: 1;
      min-width: 0;
      background: #fff;
      border-radius: 4px;
      padding: 20px;
      border-left: 4px solid #dcdfe6;
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

        &.card-orange {
            border-left-color: #e6a23c;
        }

        &.card-purple {
            border-left-color: #722ed1;
        }

        &.card-cyan {
            border-left-color: #13c2c2;
        }

        &.card-pink {
            border-left-color: #eb2f96;
        }

        .statistic-value {
            font-size: 28px;
            font-weight: bold;
            color: #303133;
            margin-bottom: 8px;
        }

        .statistic-label {
            font-size: 14px;
            color: #909399;
        }
      }
    }

  </style>
